import styled from 'styled-components';

export const Container = styled.div`
  background-color: ${({ theme }) => theme?.colors?.theme?.contentBg};
  width: 120px;
  height: 35px;
  padding: 8px 12px;
  border-radius: 32px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const Label = styled.h4`
  font-size: 0.875rem;
  color: ${({ theme }) => theme?.colors?.text?.headings};
  margin: 0;
  line-height: 18.52px;
`;

export const ProgressText = styled.p`
  font-size: 0.875rem;
  color: ${({ theme }) => theme?.colors?.text?.headings};
  margin: 0;
`;

